import { upperFirst } from 'lodash';

export function pascalCaseRpcInUrl(url: string): string {
    return `${url.substring(0, url.lastIndexOf('/'))}/${upperFirst(url.split('/').pop())}`;
}
